import * as React from "react"
import Svg, { Path } from "react-native-svg"

function KYCInstantAadharPull(props: any) {
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
            {...props}
        >
            <Path
                d="M12.5 16.667c-1.861 0-3.438-.646-4.73-1.938C6.48 13.438 5.834 11.861 5.834 10c0-1.861.646-3.437 1.938-4.729 1.291-1.292 2.868-1.938 4.729-1.938 1.861 0 3.438.646 4.73 1.938 1.29 1.292 1.937 2.868 1.937 4.73 0 1.86-.646 3.437-1.938 4.728-1.291 1.292-2.868 1.938-4.729 1.938zm-.005-1.25c1.503 0 2.783-.526 3.838-1.579 1.056-1.052 1.584-2.33 1.584-3.833 0-1.503-.527-2.783-1.579-3.838-1.052-1.056-2.33-1.583-3.833-1.583-1.503 0-2.783.526-3.838 1.578-1.056 1.052-1.584 2.33-1.584 3.833 0 1.504.526 2.783 1.579 3.839 1.052 1.055 2.33 1.583 3.833 1.583zm.65-5.688l-.02-2.437a.612.612 0 00-.18-.438.592.592 0 00-.445-.187.61.61 0 00-.625.625V10c0 .078.014.152.042.225a.62.62 0 00.146.213l2.124 2.104a.607.607 0 00.875.003.592.592 0 00.188-.437.603.603 0 00-.188-.441l-1.916-1.938zM2.293 7.292a.603.603 0 01-.446-.18.61.61 0 01-.18-.449.61.61 0 01.625-.621h2.084c.177 0 .325.06.445.18.12.121.18.27.18.448a.61.61 0 01-.625.621H2.292zm-.834 3.333a.603.603 0 01-.445-.18.61.61 0 01-.18-.448.61.61 0 01.625-.621h2.917c.177 0 .325.06.445.18s.18.27.18.448-.06.326-.18.444a.61.61 0 01-.445.177H1.458zm.834 3.334a.603.603 0 01-.446-.181.61.61 0 01-.18-.448.61.61 0 01.625-.621h2.084c.177 0 .325.06.445.18s.18.27.18.448-.06.326-.18.444a.61.61 0 01-.445.178H2.292z"
                fill="#00813B"
            />
        </Svg>
    )
}

export default KYCInstantAadharPull
